import React from 'react';
import { classNames } from '../../utils/classNames';

export type FilterTab = {
  key: string;
  label: string;
  badge?: number;
};

type FiltersTabsProps = {
  tabs: FilterTab[];
  value: string;
  onChange: (key: string) => void;
  className?: string;
  condensed?: boolean;
};

export const FiltersTabs: React.FC<FiltersTabsProps> = ({
  tabs,
  value,
  onChange,
  className,
  condensed = false,
}) => {
  return (
    <div className={classNames('max-w-full', className)}>
      <div
        className={classNames(
          'flex max-w-full items-center overflow-x-auto rounded-full border border-slate-200 bg-white p-1 shadow-soft',
          condensed ? 'px-2 py-1' : 'px-2 py-1.5'
        )}
      >
        <div className="flex min-w-max items-center gap-2">
          {tabs.map((tab) => {
            const isActive = tab.key === value;
            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => onChange(tab.key)}
                className={classNames(
                  'flex flex-shrink-0 items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500',
                  isActive
                    ? 'bg-primary-500 text-white shadow'
                    : 'text-slate-600 hover:bg-surface-subtle'
                )}
              >
                <span>{tab.label}</span>
                {tab.badge !== undefined ? (
                  <span
                    className={classNames(
                      'inline-flex h-5 min-w-[1.5rem] items-center justify-center rounded-full bg-white px-2 text-[11px] font-semibold',
                      isActive ? 'text-primary-600' : 'text-slate-500'
                    )}
                  >
                    {tab.badge}
                  </span>
                ) : null}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FiltersTabs;

